import { useState, useEffect } from "react"; 
import { jwtFetch } from "./utils/apiClient";
import { useParams, useNavigate } from "react-router-dom";
import { format } from "date-fns";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { config, encodeBase64RequestBody, nameFormat } from "./Components/Config";
import Menu from "./Components/Menu";
import Header from "./Components/Header";

const SubsidiaryAdd = () => {
  const { id_company } = useParams();
  const [ companies, setCompanies ] = useState(null);
  const [ subcompanies, setSubcompanies ] = useState(null);
  const [ companyGroup, setCompanyGroup ] = useState(null);
  const [ companyName, setCompanyName ] = useState('');
  const [ companyAddress, setCompanyAddress ] = useState(''); 
  const [ companyBillingName, setCompanyBillingName ] = useState('');
  const [ companyBillingAddress, setCompanyBillingAddress ] = useState('');
  const [ companyPhone, setCompanyPhone ] = useState('');
  const [ companyFax, setCompanyFax ] = useState('');
  const [ companyNpwpNumber, setCompanyNpwpNumber ] = useState(null);
  const [ companyNpwpFiles, setCompanyNpwpFiles ] = useState(null);
  const [ companyStatus, setCompanyStatus ] = useState(true);
  const [ selectedName, setSelectedName ] = useState(null);
  const [ isLoadingSubmit, setIsLoadingSubmit ] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    getCompanies();
    getSubcompanies();
  }, []);

  useEffect(() => {
    if (companies && id_company) {
      changeCompanyData(id_company);
    }
  }, [companies]);
  
  useEffect(() => {
    if (selectedName) {
      setCompanyName(selectedName.label ? nameFormat(selectedName.label) : '');
    }
  }, [selectedName]);
  
  const changeSubcompanyName = (name) => {
    setSelectedName({
      value: 0,
      label: name,
      isDisabled: false
    });
    setCompanyName(name);
  }

  const getSubcompanies = async () => {
    try {
      const fetchCompanies = await jwtFetch(config.ENDPOINT + 'get/subcompany', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: encodeBase64RequestBody({})
      });
      const responseCompanies = await fetchCompanies.json();
      if (responseCompanies.status === 200) {
        const subcompanies = [];
        for (let c in responseCompanies.data) {
          subcompanies.push({
            value: responseCompanies.data[c].id_company,
            label: responseCompanies.data[c].company_name,
            isDisabled: true
          });
        }
        setSubcompanies(subcompanies);
      } else {
        alert(responseCompanies.message);
      }
    } catch (error) {
      console.error('Error in getSubcompanies:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  }

  const getCompanies = async () => {
    try {
      const requestCompanies = {
        "company_status": 'Active'
      };
      const fetchCompanies = await jwtFetch(config.ENDPOINT + 'get/company', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestCompanies)
      });
      const responseCompanies = await fetchCompanies.json();
      if (responseCompanies.status === 200) {
        for (let i in responseCompanies.data) {
          responseCompanies.data[i].value = responseCompanies.data[i].id_company;
          responseCompanies.data[i].label = responseCompanies.data[i].company_name;
        }
        setCompanies([...responseCompanies.data].sort((a, b) => (a.company_name || '').localeCompare(b.company_name || '')));
      } else {
        alert(responseCompanies.message);
      }
    } catch (error) {
      console.error('Error in getCompanies:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  };

  const changeCompanyData = (value) => {
    const company = companies.find(company => company.id_company == value);
    setCompanyGroup(company);
  }
  
  const uploadFile = async (formData) => {
    try {
      const responseUploadFile = await jwtFetch(config.ENDPOINT + 'upload/gdrive', {
        method: 'POST',
        body: formData,
      });
      if (!responseUploadFile.ok) {
        throw new Error(`Upload failed with status: ${responseUploadFile.status}`);
      }
      const resultUploadFile = await responseUploadFile.json();
      if (resultUploadFile.status === 200) {
        return resultUploadFile.data;
      } else {
        alert(`Upload error: ${resultUploadFile.message}`);
      }
    } catch (error) {
      console.error('Error in uploadFile:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  };
  
  const submitSubcompanyAdd = async (e) => {
    try {
      e.preventDefault();
      setIsLoadingSubmit(true);
      const crmUser = JSON.parse(localStorage.getItem('crmUser'));

      let companyNpwp = null;
      if (companyNpwpFiles) {
        const formData = new FormData();
        companyNpwpFiles.forEach((companyNpwpFile) => {
          formData.append('files', companyNpwpFile);
        });
        const responseUploadFile = await uploadFile(formData);
        if (responseUploadFile) {
          companyNpwp = responseUploadFile;
        }
      }

      const requestSubcompanyAdd = {
        "company_id": companyGroup.value,
        "company_name": companyName,
        "company_address": companyAddress,
        "company_billing_name": companyBillingName,
        "company_billing_address": companyBillingAddress,
        "company_phone": companyPhone,
        "company_fax": companyFax,
        "company_npwp_number": companyNpwpNumber,
        "company_npwp_files": JSON.stringify(companyNpwp),
        "company_status": companyStatus === true ? 'Active' : 'Inactive',
        "created_on": format(new Date(), "yyyy-MM-dd HH:mm:ss"),
        "created_by": crmUser.user_keyid,
      }
      const fetchSubcompanyAdd = await jwtFetch(config.ENDPOINT + 'create/subcompany', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: encodeBase64RequestBody(requestSubcompanyAdd)
      });
      const responseSubcompanyAdd = await fetchSubcompanyAdd.json();
      if (responseSubcompanyAdd.status === 200) {
        window.location.href = '/client/subsidiary';
      } else {
        alert(responseSubcompanyAdd.message);
        setIsLoadingSubmit(false);
      }
    } catch (error) {
      console.error('Error in submitSubcompanyAdd:', error);
      alert('An error occurred: ' + (error.message || error));
      setIsLoadingSubmit(false);
    }
  }

  return (
    <div id="subsidiary-add">
      <div className="container-fluid p-0">
        <div className="row g-0 mh-100vh">
          <div className="col-md-2 border-end">
            <div className="d-md-flex d-none align-items-center justify-content-center p-1 h-48">
              <a className="h-100" href="/dashboard"><img className="h-100" src="/cuancuan.png" alt="PointStar"/></a>
            </div>
            <hr className="m-0"/>
            <Menu active="client"/>
          </div>
          <div className="col-md-10">
            <Header/>
            <hr className="m-0"/>
            <div className="main">
              <div className="p-4">

                <section className="mb-4">
                  <div className="fs-24 mb-3"><button className="btn btn-link" onClick={() => navigate(-1)}><i className="bi bi-arrow-left"/></button> Subsidiary Add</div>
                  <form className="row" onSubmit={(e) => submitSubcompanyAdd(e)}>
                    <div className="col-md-6">
                      <div className="row form-group align-items-center mb-2">
                        <div className="col-md-4">
                          <label>Company Group <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8">
                          <Select value={companyGroup} options={companies} placeholder="" onChange={(e) => changeCompanyData(e.value)} required/>
                        </div>
                      </div>
                      <div className="row form-group align-items-center mb-2">
                        <div className="col-md-4">
                          <label>Company Name <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8">
                          <CreatableSelect options={subcompanies} value={selectedName} placeholder="Type name..." onCreateOption={(e) => changeSubcompanyName(e)} isClearable required/>
                        </div>
                      </div>
                      <div className="row form-group align-items-center mb-2">
                        <div className="col-md-4">
                          <label>Legal Name <span className="text-danger">*</span></label>
                        </div>
                        <div className="col-md-8">
                          <input className="form-control" type="text" value={companyBillingName} onChange={(e) => setCompanyBillingName(e.target.value)} required />
                        </div>
                      </div>
                      <div className="row form-group align-items-baseline mb-2">
                        <div className="col-md-4">
                          <label>Billing Address</label>
                        </div>
                        <div className="col-md-8">
                          <textarea className="form-control" value={companyBillingAddress} onChange={(e) => setCompanyBillingAddress(e.target.value)} />
                        </div>
                      </div>
                      <div className="row form-group align-items-baseline mb-2">
                        <div className="col-md-4">
                          <label>Mailing Address</label>
                        </div>
                        <div className="col-md-8">
                          <textarea className="form-control" value={companyAddress} onChange={(e) => setCompanyAddress(e.target.value)} />
                        </div>
                      </div>
                      <div className="row form-group align-items-center mb-2">
                        <div className="col-md-4">
                          <label>Phone Number</label>
                        </div>
                        <div className="col-md-8">
                          <input className="form-control" type="text" value={companyPhone} onChange={(e) => setCompanyPhone(e.target.value)} />
                        </div>
                      </div>
                      <div className="row form-group align-items-center mb-2">
                        <div className="col-md-4">
                          <label>Fax</label>
                        </div>
                        <div className="col-md-8">
                          <input className="form-control" type="text" value={companyFax} onChange={(e) => setCompanyFax(e.target.value)}/>
                        </div>
                      </div>
                      <div className="row form-group align-items-center mb-4">
                        <div className="col-md-4">
                          <label>Status</label>
                        </div>
                        <div className="col-md-8">
                          <div className="form-check form-switch">
                            <input id="status" className="form-check-input" type="checkbox" value={true} onChange={() => setCompanyStatus(!companyStatus)} checked={companyStatus} />
                            <label htmlFor="status" className="form-check-label">{companyStatus ? 'Active' : 'Inactive'}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="card mb-4">
                        <div className="card-body">
                          <div className="fs-18 mb-3">NPWP</div>
                          <div className="row form-group align-items-baseline mb-2">
                            <div className="col-md-4">
                              <label>Number</label>
                            </div>
                            <div className="col-md-8">
                              <input className="form-control" type="text" value={companyNpwpNumber} onChange={(e) => setCompanyNpwpNumber(e.target.value)}/>
                            </div>
                          </div>
                          <div className="row form-group align-items-baseline mb-2">
                            <div className="col-md-4">
                              <label>File</label>
                            </div>
                            <div className="col-md-8">
                              <input className="form-control" type="file" multiple={true} accept=".pdf, .png, .jpg, .jpeg, .gif, .webp, .svg, .bmp, .avif, .csv, .xls, .xlsx" onChange={(e) => setCompanyNpwpFiles(Array.from(e.target.files))}/>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="d-flex justify-content-end mb-4">
                        <button className="btn btn-sm btn-link text-danger" type="button" onClick={() => window.location.href = '/client/subsidiary'}>Cancel</button>
                        <button className="btn btn-sm btn-primary ms-2" type="submit" disabled={isLoadingSubmit}>{isLoadingSubmit ? 'Loading...' : 'Save'}</button>
                      </div>
                    </div>
                  </form>
                </section>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubsidiaryAdd;


